import { Subject } from "rxjs";
export var gameMapping = {};
export var gameList = [];
export var liveGameList = [];
export var providerList = [];
export var gamesUpdateSubject = new Subject();
export var gameSettings = { detailOpen: false };
export var gameDetailSubject = {};
